import {AbortCleanroomDialog} from '@/modules/cleanroom/components/abort/abort-cleanroom-dialog'
import {determineSequenceScannableItems} from '@/modules/cleanroom/functions'
import {useCleanroomSequenceBatches} from '@/modules/cleanroom/hooks/use-cleanroom-sequence-batches'
import {PatientTherapySequence} from '@cypro/engine/schema'
import {useTranslate} from '@tolgee/react'
import {useMemo} from 'react'

// Opens the cleanroom abort dialog from the drawer; materials are derived from the order.
export function CancelProductionDialog({sequence}: {sequence: PatientTherapySequence}) {
  const {t} = useTranslate('cleanroom')
  const order = useCleanroomSequenceBatches(sequence)
  const scannableItems = useMemo(
    () => determineSequenceScannableItems(t, order.batches, order.restVialEntries, order.returnEntries),
    [t, order]
  )

  return (
    <AbortCleanroomDialog
      sequence={sequence}
      order={order}
      scannableItems={scannableItems}
      onAborted={() => {}}
      cancel
    />
  )
}
